import React from "react";
import { LayoutChannels } from "ComponentsUI/Channels";
import { inject, observer } from "mobx-react";

@inject("ApplicationModel")
@observer
export default class ChannelsContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			name: "",
			quality: [],
		};
	}

	changeName(value) {
		this.setState({
			name: value,
		});
	}

	changeQuality(values) {
		this.setState({
			quality: values,
		});
	}

	render() {
		let text = this.props.ApplicationModel.text;
		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;
		let provider = this.props.tariff?.provider;
		let tariff = this.props.tariff;
		if (!provider) {
			return null;
		}

		let channelsForSelectCheck = JSON.parse(JSON.stringify(tariff?.tvPackage[0]?.channels))
			.filter((item) => {
				return !!item.name && item.name.toLowerCase().indexOf(this.state.name.toLowerCase()) === 0;
			})
			.sort(function (a, b) {
				if (a.name >= b.name) return 1;
				if (a.name < b.name) return -1;
			});

		let channels = JSON.parse(JSON.stringify(tariff?.tvPackage[0]?.channels))
			.filter((item) => {
				return !!item.name && item.name.toLowerCase().indexOf(this.state.name.toLowerCase()) === 0;
			})
			.sort(function (a, b) {
				if (a.name >= b.name) return 1;
				if (a.name < b.name) return -1;
			});

		if (!!this.state.quality.length) {
			let tempChannels = channels;
			channels = [];
			tempChannels.forEach((channel) => {
				this.state.quality.forEach((choosedStateQuality) => {
					channel.quality.forEach((channelQuality) => {
						if (choosedStateQuality.code === channelQuality.code) {
							channels.push({
								...channel,
								name: `${channel.name} ${channelQuality.name}`,
							});
						}
					});
				});
			});
		}

		let channelsText = "";
		if (tariff.tv && (tariff.tv.channels || tariff.tv.channels_hd)) {
			channelsText = tariff.tv.channels;
			if (tariff.tv.channels_hd) {
				channelsText = !!channelsText
					? channelsText + " + " + tariff.tv.channels_hd + "HD"
					: tariff.tv.channels_hd + "HD";
			}
		}

		return (
			<LayoutChannels
				text={text}
				windowSizes={windowSizes}
				provider={provider}
				channelsText={channelsText}
				data={this.state}
				changeName={(val) => this.changeName(val)}
				changeQuality={(vals) => this.changeQuality(vals)}
				tariffName={this.props.tariff.name}
				channels={channels}
				quality={this.state.quality}
				channelsForSelectCheck={channelsForSelectCheck}
			/>
		);
	}
}
